import React from 'react'

export default class ManagerProfileDigest extends React.Component {
  render() {
    return (
      <div className="profile-digest">
        <h4>مدیریت سامانه</h4>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/manager/ManagerProfileDigest.js